import "react";
import e from "../../../../_virtual/index.js";
import { Global as r } from "../../../@emotion/react/dist/emotion-react.browser.esm.js";
import { jsx as n } from "react/jsx-runtime";
function p(t) {
  return t == null || Object.keys(t).length === 0;
}
function f(t) {
  const {
    styles: o,
    defaultTheme: s = {}
  } = t;
  return /* @__PURE__ */ n(r, {
    styles: typeof o == "function" ? (l) => o(p(l) ? s : l) : o
  });
}
process.env.NODE_ENV !== "production" && (f.propTypes = {
  defaultTheme: e.object,
  styles: e.oneOfType([e.array, e.string, e.object, e.func])
});
export {
  f as default
};
